// extracted by mini-css-extract-plugin
export default {"download_icon":"QrCode_download_icon__KtL8C"};